import {  isLoaded, isLoading } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { getSubTasks } from "./getSubtask";

export async function addSubTaskToWorkflow(state, dispatch, getUser, mainTaskId, moduleId,assignedTo, handleClose,SUBTASK_ADD, SUBTASK, template_story_id, project_id) {
  dispatch(isLoading());
  if (state.targetDate.value !== "" && state.taskTitle.value !== "" && state.taskDescription.value !== "" && state.acceptanceCriteria.value !== "" ) {
    try {
      var response = await API.post("tasks_workflow.php", {
        assignedBy: getUser.empId,
        assignedTo: state.userSelected === "" ? assignedTo : state.userSelected,
        "projectId": (project_id || getUser.projectId),
        maintaskId: mainTaskId,
        moduleId: moduleId,
        crop: getUser.corp,
        action: "add",
        title: state.taskTitle.value,
        description: state.taskDescription.value,
        targetDate:state.targetDate.value,
        acceptanceCriteria: state.acceptanceCriteria.value,
        template_story_id: template_story_id,
        message: `${SUBTASK} added as a Workflow`
      }, {}, false);
      if (response.status === 'True') {
        dispatch(getSubTasks(dispatch, getUser, mainTaskId))
        Alert("success", SUBTASK_ADD);
      }
      else{
        Alert('warning', `${SUBTASK} Already Existed!`);
      }
    } catch (error) {
      Alert('warning', error.message);
      dispatch(isLoaded());
    }
    handleClose()
  } else {
    Alert("warning", "please give task information")
  }
}